<template>
  <section class="inventory--part-details animated fadeIn">
    <div class="list-group-item mb-2">
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.innerContentInspection_InnerContents"
      >
        <span class="col-form-label">Inspect inner contents, packaging, bag seal and labels</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.innerContentInspection_BagSeal"
      >
        <span class="col-form-label">Inspect bag seal</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.innerContentInspection_CompareLabels"
      >
        <span class="col-form-label">Compare inner labels with outter carton labels</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.innerContentInspection_SealDate"
      >
        <span class="col-form-label">Verify bag seal date and product date code</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.innerContentInspection_MSLLevel"
      >
        <span
          class="col-form-label"
        >Verify the product is properly packaged for the required MSL and compare the MSL level with datasheet</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.innerContentInspection_ESDCompliant"
      >
        <span class="col-form-label">Verify the package is ESD compliant</span>
      </b-form-radio-group>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {FIELDS}  from '../../constants'
export default {
  name: 'ideaInnerContents',
  components: {},
  props: {
    inspectionDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        innerContentInspection_InnerContents: this.inspectionDetails[FIELDS.INNER_CONTENT_INSPECTION__INNER_CONTENTS] || '',
        innerContentInspection_BagSeal: this.inspectionDetails[FIELDS.INNER_CONTENT_INSPECTION__BAG_SEAL] || '',
        innerContentInspection_CompareLabels: this.inspectionDetails[FIELDS.INNER_CONTENT_INSPECTION__COMPARE_LABELS] || '',
        innerContentInspection_SealDate: this.inspectionDetails[FIELDS.INNER_CONTENT_INSPECTION__SEAL_DATE] || '',
        innerContentInspection_MSLLevel: this.inspectionDetails[FIELDS.INNER_CONTENT_INSPECTION__MSLLEVEL] || '',
        innerContentInspection_ESDCompliant: this.inspectionDetails[FIELDS.INNER_CONTENT_INSPECTION__ESDCOMPLIANT] || '',
      },
    };
  },
  computed: {},
  mounted() {},
};
</script>